module.exports = __webpack_public_path__ + "static/monitaur-3636dc77355ca37292be29fc13a215fc.png";